import Cookies from "js-cookie";

export default class CookieManager {
    addEventListeners(eventDispatcher) {
        Array.prototype.slice.call(this.categories).forEach((category) => {
            document.addEventListener(eventDispatcher.declineCategoryEventName(category.name),
                () => { this.declineCategory(category.name); }, false);
        });
    }

    constructor(config) {
        this.categories = config.Categories;
    }

    init(eventDispatcher) {
        this.addEventListeners(eventDispatcher);
    }

    declineCategory(categoryName) {
        function cookieExists(cookieName, allCookies) {
            return !!(allCookies[cookieName]);
        }

        function deleteCookie(cookieName) {
            const d = new Date();
            d.setTime(1);
            const expires = `expires=${d.toUTCString()}`;
            window.document.cookie = `${cookieName}=; ${expires}`;
        }

        const category = this.categories.find(x => x.name === categoryName);
        if (!category) {
            return;
        }
        const allCookies = Cookies.get();
        const cookiesInCategory = Array.prototype.slice.call(category.cookies.filter(x => cookieExists(x, allCookies)));

        cookiesInCategory.forEach((cookie) => { deleteCookie(cookie); });
    }
}
